var render = function render(_c,_vm){return _c('div',{staticClass:"list",class:_vm.data.staticClass,attrs:{"role":"listbox"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }